import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=492dc4fe&scoped=true"
import script from "./technology.vue?vue&type=script&lang=js"
export * from "./technology.vue?vue&type=script&lang=js"
import style0 from "./technology.vue?vue&type=style&index=0&id=492dc4fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492dc4fe",
  null
  
)

export default component.exports